export default {
    getRequest: state => state.request,
    getRequestSales: state => state.requestSales,
    getRequestPurchase: state => state.requestPurchase
  }
  